import { useQuery } from '@tanstack/react-query';
import { CLIENT_ID_QUERY_KEY } from '@/consts/const';
import { useFetch } from '@/hooks/useFetch';
import { useSearchQuery } from '@/hooks/useSearchQuery';
import type { GetClientDetailsResponse } from '@/types/clientDetailsApiTypes';
import { CLIENT_DETAILS_QUERY_KEY } from '../../consts/client-detail';

export type UseGetClientDetailsQueryOptions = {
  clientIdOverride?: string | null;
};

export const useGetClientDetailsQuery = (options?: UseGetClientDetailsQueryOptions) => {
  const [searchQuery] = useSearchQuery();
  const clientIdFromUrl = searchQuery.get(CLIENT_ID_QUERY_KEY);
  const clientId = options?.clientIdOverride ?? clientIdFromUrl;
  const { doFetch: getClientDetails } = useFetch<void, GetClientDetailsResponse>();

  return useQuery({
    queryKey: [CLIENT_DETAILS_QUERY_KEY, clientId],
    queryFn: () => getClientDetails(`/api/client-details/${clientId}`),
    enabled: !!clientId,
    retry: 1,
  });
};
